/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { loadPolyfills } from './polyfills';
import * as serviceWorker from './serviceWorker';

import 'antd/dist/reset.css';
import './styles/main.less';
import '@fortawesome/fontawesome-free/css/all.min.css';

// render app after polyfills
loadPolyfills()
  .then(() => {
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
      /*  <React.StrictMode> */
      <App />
      /* </React.StrictMode> */
    );
  })
  .catch(console.error);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
